export const addPokemon = value => ({
    type: 'TOGGLE_POKEMON',
    newValue: value
});
